import axios from "axios";

const apiClient = axios.create({
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
    },
});

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error.response) {
            console.error("❌ Сетевая ошибка:", error);
            return Promise.reject({ message: "Ошибка соединения." });
        }

        const { status, data } = error.response;

        switch (status) {
            case 400:
                console.error("Ошибка валидации:", data);
                break;

            case 403:
                console.warn("Доступ запрещён:", data);
                break;

            case 404:
                console.warn("Ресурс не найден:", data);
                break;

            case 500:
                console.error("Ошибка сервера:", data);
                break;

            default:
                console.error(`Ошибка ${status}:`, data);
        }

        return Promise.reject(data);
    }
);

export default apiClient;
